import user from 'js/lib/user';

import sessionStorageEx from 'bundles/common/utils/sessionStorageEx';

const getStorageKey = (courseId: string): string => {
  const userId = String(user.get().id);
  return `adaptive-learning-preference:${courseId}:${userId}`;
};

/**
 * Returns the stored adaptive learning preference, defaulting to `true` if none is saved.
 */
export const getAdaptiveLearningPreference = (courseId: string): boolean => {
  return sessionStorageEx.getItem(getStorageKey(courseId), (item) => item === 'true', true);
};

export const setAdaptiveLearningPreference = (courseId: string, enabled: boolean): void => {
  sessionStorageEx.setItem(getStorageKey(courseId), enabled, String);
};
